import React, { useEffect, useState } from 'react';
import { Tag } from 'antd';
import { DisconnectOutlined } from '@ant-design/icons';

function getIsOnline() {
  // navigator.onLine is best-effort; still good for global UX indicator.
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine !== false;
}

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(getIsOnline());

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Sync once on mount (covers initial state after hydration)
    setIsOnline(getIsOnline());

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        zIndex: 2000,
        pointerEvents: 'none',
      }}
      aria-live="polite"
      aria-atomic="true"
    >
      <Tag
        color="error"
        style={{
          padding: '8px 12px',
          borderRadius: 999,
          boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
          fontSize: 14,
          marginInlineEnd: 0,
        }}
      >
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <DisconnectOutlined />
          Offline
        </span>
      </Tag>
    </div>
  );
};

export default OfflineIndicator;
